export default __webpack_public_path__ + "static/media/aquagym.50f25db3.svg";